import React from 'react';
import './KeywordStuffingSection.css';
import { useTranslation } from 'react-i18next';
const KeywordStuffingSection = ({ data }) => {
  const { t } = useTranslation();
  
  const currentText = data?.currentText || [];
  const initialText = data?.initialText || [];
  
  return (
    <div className="keyword-stuffing-section">
      {/* Current Text Analysis */}
      {currentText.length > 0 && (
        <div className="keyword-section">
          <div className="keyword-section-title">
            {t('Dans le texte actuel')} :
          </div>
          <ul className="keyword-list">
            {currentText.map((item, index) => (
              <li key={`current-${index}`}>
                <span className="keyword-name">{item.keyword}</span>
                <span className="keyword-percentage">({item.percentage}%)</span>
              </li>
            ))}
          </ul>
        </div>
      )}
      {currentText.length > 0 && (
        <hr className="position-divider" />
      )}

      {/* Initial Text Analysis */}
      {initialText.length > 0 && (
        <div className="keyword-section">
          <div className="keyword-section-title">
            {t('Dans le texte initial')} :
          </div>
          <ul className="keyword-list">
            {initialText.map((item, index) => (
              <li key={`initial-${index}`}>
                <span className="keyword-name">{item.keyword}</span>
                <span className="keyword-percentage">
                  ({item.percentage?.toLocaleString('fr-FR') || item.percentage}%)
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Recommendation */}
      {data?.recommendation && (
        <div className="ux-recommendation">
          <span className="recommendation-icon"></span>

          <div className="recommendation-content">
            <span className="recommendation-label">
              {t('Notre recommandation')} :{' '}
            </span>
            <span className="recommendation-text">
              {t(data.recommendation)}
            </span>
          </div>
        </div>
      )}
      {data?.gratification && (
        <div className="success-message">
          <span className="emoji">🎉</span> {t(data.gratification)}
        </div>
      )}
    </div>
  );
};

export default KeywordStuffingSection;
